import { all } from 'redux-saga/effects'

import { dataSaga } from './data/saga'
import { employersSaga } from './employers/sagas'
import { employerSaga as currentEmployerSaga } from './employer/sagas'

export function* employerSaga() {
  yield all([dataSaga(), employersSaga(), currentEmployerSaga()])
}
